import React from "react";
import {
  Clock,
  Smartphone,
  TrendingUp,
  Store,
  CreditCard,
  Star,
  type LucideIcon,
} from "lucide-react";

/** Tông teal brand Lookme (leaflet) */
export const TEAL = "#26BAB9";

/** Từ khoá nhấn màu teal đậm */
export const K: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <strong className="font-extrabold" style={{ color: TEAL }}>
    {children}
  </strong>
);

export interface Benefit {
  Icon: LucideIcon;
  /** Key trong i18n/locales/*.json — nội dung đã chuyển qua t() ở Benefits.tsx */
  titleKey: string;
  descKey: string;
}

export const BENEFITS: Benefit[] = [
  { Icon: Clock, titleKey: "partner.benefit1Title", descKey: "partner.benefit1Desc" },
  { Icon: Smartphone, titleKey: "partner.benefit2Title", descKey: "partner.benefit2Desc" },
  { Icon: TrendingUp, titleKey: "partner.benefit3Title", descKey: "partner.benefit3Desc" },
  { Icon: Store, titleKey: "partner.benefit4Title", descKey: "partner.benefit4Desc" },
  { Icon: CreditCard, titleKey: "partner.benefit5Title", descKey: "partner.benefit5Desc" },
  { Icon: Star, titleKey: "partner.benefit6Title", descKey: "partner.benefit6Desc" },
];

/** Key trong i18n/locales/*.json — nội dung đã chuyển qua t() ở Steps.tsx */
export const STEPS = [
  { n: "1", titleKey: "partner.step1Title", descKey: "partner.step1Desc" },
  { n: "2", titleKey: "partner.step2Title", descKey: "partner.step2Desc" },
  { n: "3", titleKey: "partner.step3Title", descKey: "partner.step3Desc" },
  { n: "4", titleKey: "partner.step4Title", descKey: "partner.step4Desc" },
];

/**
 * `value` là giá trị thật gửi lên BE/Google Sheet (giữ tiếng Việt như cũ để
 * không phá dữ liệu đã lưu); `labelKey` dùng để hiển thị theo locale qua
 * t() ở PartnerForm — tránh label tiếng Việt cứng khi xem bản /en.
 */
export const CATEGORIES: { value: string; labelKey: string }[] = [
  { value: "Spa & chăm sóc da", labelKey: "partner.category1" },
  { value: "Massage & gội đầu dưỡng sinh", labelKey: "partner.category2" },
  { value: "Nail & mi", labelKey: "partner.category3" },
  { value: "Salon tóc & makeup", labelKey: "partner.category4" },
  { value: "Thẩm mỹ viện", labelKey: "partner.category5" },
  { value: "Khác", labelKey: "partner.category6" },
];

/** Gợi ý tỉnh/thành phổ biến — vẫn cho phép gõ tự do (datalist) */
export const PROVINCES = [
  "TP. Hồ Chí Minh",
  "Hà Nội",
  "Đà Nẵng",
  "Hải Phòng",
  "Cần Thơ",
  "Bình Dương",
  "Đồng Nai",
  "Khánh Hoà",
  "Bà Rịa - Vũng Tàu",
  "Lâm Đồng",
  "Thừa Thiên Huế",
  "Quảng Ninh",
  "Nghệ An",
  "Thanh Hoá",
  "Bắc Ninh",
];


